// src/components/SensorList.js
import React, { useState, useEffect } from 'react';
import { Box, Table, Thead, Tbody, Tr, Th, Td, IconButton, Button } from '@chakra-ui/react';
import { getSensors } from '../utils/firebase.utils';
import { EditIcon, ViewIcon } from '@chakra-ui/icons';
import SensorForm from './SensorForm';

const SensorList = ({ onEdit, onView }) => {
  const [sensors, setSensors] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [selectedSensor, setSelectedSensor] = useState(null);

  useEffect(() => {
    const fetchSensors = async () => {
      const sensorsList = await getSensors();
      setSensors(sensorsList);
    };
    fetchSensors();
  }, []);

  const handleFormSubmit = () => {
    setShowForm(false);
    const fetchSensors = async () => {
      const sensorsList = await getSensors();
      setSensors(sensorsList);
    };
    fetchSensors(); // Refresh the list after adding a new sensor
  };

  const handleEdit = (sensor) => {
    setSelectedSensor(sensor);
    setShowForm(true);
  };

  return (
    <Box p={4} overflowX="auto">
      <Button onClick={() => { setShowForm(!showForm); setSelectedSensor(null); }} mb={4}>
        {showForm ? 'Cancel' : 'Add Sensor'}
      </Button>
      {showForm && <SensorForm sensor={selectedSensor} onSubmit={handleFormSubmit} />}
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Type</Th>
            <Th>Status</Th>
            <Th>Last Sync</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {sensors.map(sensor => (
            <Tr key={sensor.id}>
              <Td>{sensor.name}</Td>
              <Td>{sensor.type}</Td>
              <Td>{sensor.status}</Td>
              <Td>{sensor.lastSync.toLocaleString()}</Td>
              <Td>
                <IconButton
                  icon={<ViewIcon />}
                  onClick={() => onView(sensor)}
                  aria-label="View Sensor"
                  mr={2}
                />
                <IconButton
                  icon={<EditIcon />}
                  onClick={() => handleEdit(sensor)}
                  aria-label="Edit Sensor"
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default SensorList;